// js/helper/currency.js

// Safely get the money format from Eurus theme
function getMoneyFormat() {
  // Eurus uses window.themeVariables
  if (window.themeVariables?.settings?.moneyWithCurrencyFormat) {
    return window.themeVariables.settings.moneyWithCurrencyFormat;
  }
  if (window.themeVariables?.settings?.moneyFormat) {
    return window.themeVariables.settings.moneyFormat;
  }
  if (window.theme?.settings?.moneyWithCurrencyFormat) {
    return window.theme.settings.moneyWithCurrencyFormat;
  }
  // Fallback for INR (your store)
  return "Rs. {{amount}}";
}

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || getMoneyFormat(); // ✅ safe fallback

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) return 0;

    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  let value = "";
  const match = formatString.match(placeholderRegex);
  if (!match) return cents; // ✅ guard against null match crash

  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

// ✅ Safe currency format variables
const currencyFormat = getMoneyFormat();
const currencyFormatWithoutCode =
  currencyFormat.match(/\{\{\s*\w+\s*\}\}/)?.[0] || "{{ amount }}";

$(document).ready(function(){

    // Plus button click
    $('body').on('click', '.quantity-selector__button:last-child', function() {
    const $input = $(this).siblings('.quantity-selector__input');
    const currentVal = parseInt($input.val()) || 0;
    $input.val(currentVal + 1).trigger('change');
    });

    // Minus button click  
    $('body').on('click', '.quantity-selector__button:first-child', function() {
    const $input = $(this).siblings('.quantity-selector__input');
    const currentVal = parseInt($input.val()) || 0;
    const min = parseInt($input.attr('min')) || 0; // ✅ 0 se niche nahi jayega
    if (currentVal > min) {
        $input.val(currentVal - 1).trigger('change');
    }
    });
    
    function activecheck(addedcnt,bundle_price,bundle_compare_price){
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.quantity-selector .quantity-selector__button:last-child').attr('disabled','disabled');
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart</span></span><span class="loader-button__loader"><div class="spinner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="200" height="200" style="shape-rendering: auto; display: block; background: transparent;" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle stroke-dasharray="164.93361431346415 56.97787143782138" r="35" stroke-width="10" stroke="#ffffff" fill="none" cy="50" cx="50">
        <animateTransform keyTimes="0;1" values="0 50 50;360 50 50" dur="1s" repeatCount="indefinite" type="rotate" attributeName="transform"></animateTransform>
      </circle><g></g></g><!-- [ldio] generated by https://loading.io --></svg></div></span>`)
      .addClass('readytoadd button--gradient')
      .removeClass('button--outline')
      .removeAttr('disabled');
      // $('.bundle-preview_cart-prices').show();
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundleamount, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_price, currencyFormat));
      if(bundle_compare_price > bundle_price){
        var savings = Math.round(((bundle_compare_price - bundle_price) * 100) / bundle_compare_price);
        $('.bundle-preview_cart-prices .save-percent').html(`-${savings}%`);
      }
    }else{
      $('.quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Add to cart').removeClass('readytoadd button--gradient').attr('disabled','disabled');
      // $('.bundle-preview_cart-prices').hide();
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundle_price, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      if(bundle_compare_price > bundle_price){
        var savings = Math.round(((bundle_compare_price - bundle_price) * 100) / bundle_compare_price);
        $('.bundle-preview_cart-prices .save-percent').html(`-${savings}%`);
      }
    }

    $('#bundle-count-number').html(addedcnt);
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }

  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));

    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);
    console.log(bundle_compare_price)
    activecheck(addedcnt,bundle_price,bundle_compare_price);    

    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient');
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);

    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item hasicon" 
    data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
    data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
    data-price="${$(this).closest('.product-item').attr('data-product-price')}"
    data-compare_price="${parseInt($(this).closest('.product-item').attr('data-product-compareprice'))}"
    data-qty="1"
    >
      <div class="bundle-preview_cart-item-wrapper">
        <img src="${featuredimage}" loading="lazy" width="60" height="60" alt="">
        <div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 329.269 329" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0" fill="#fff" opacity="1" data-original="#000000" class=""></path></g></svg></div>
        <div class="bundle-preview_car-item-qty text--xsmall">x1</div>
      </div>
    </div>`;
    $('.bundle-preview_cart-items').append(itembox);
    $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();
    // $(this).find('.product-item__cta-text').html(`Added`);
    $(this).siblings('.bunle-product-item-remove').addClass('active');

    
    // var itembox = `<div class="bundle-preview_cart-item-wrapper">
    // <img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall">x</div></div>`; 

    // $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    // $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).removeClass('hasblank');    
  });
  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:last-child', function(e){
    e.preventDefault();
    addedcnt += 1;    
    var prevval = $(this).closest('.quantity-selector').find('input').val();
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  });
    $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:first-child', function(e){
        e.preventDefault();    
        addedcnt = addedcnt - 1;
        var prevval = parseInt($(this).closest('.quantity-selector').find('input').val());
        console.log(prevval,'prevval')
        bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
        bundle_price = bundle_price - parseInt($(this).closest('.product-item').attr('data-product-price'));
        activecheck(addedcnt,bundle_price,bundle_compare_price); 
        if(prevval == 0){
        console.log('iffff');
        $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove();  
        $(this).closest('.quantity-selector').hide();
        // $(this).find('.product-item__cta-text').html(`Add To Box`);
        $(this).siblings('.bunle-product-item-remove').removeClass('active');
        $(this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
        }else{
        $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
        }
    });
    $('body').on('click','.bundle-preview_car-item-remove', function(){
        addedcnt = addedcnt - $(this).closest('.bundle-preview_cart-item').attr('data-qty');
        bundle_compare_price = bundle_compare_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-compare_price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));
        bundle_price = bundle_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));   
        console.log(bundle_price);
        activecheck(addedcnt,bundle_price,bundle_compare_price); 

        $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
        $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show().removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
        // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');
        $(this).closest('.bundle-preview_cart-item').remove();
    });

    $('body').on('click','.bundle-add_to_cart_button.readytoadd', function(){        
        var $btn = $(this);
        $btn.attr("aria-busy",true);
        $btn.addClass('active');
        var items = [];
        $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
        var val = $(this).attr('data-vid');         
        var qty = $(this).attr('data-qty');         
        items.push({
            quantity: qty,
            id: val
        });   
        });      
        
        var data = {items};
        console.log('data',data)
        // var data = theme.utils.serialize(this.form);
    
        fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body:  JSON.stringify({ "items": items, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        })
        .then(response => response.json())
        .then(function(data) {      

          $btn.removeAttr('aria-busy');

          if (data.status) {
            console.error('Add to cart failed:', data.description);
            return;
          }

          $btn.removeClass('active');

          if (data.sections) {
            Alpine.store('xCartHelper').reRenderSections(data.sections);
          }

          if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
            Alpine.store('xQuickView').show = false;
          }

          Alpine.store('xCartHelper').currentItemCount =
            parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || 0);

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

          // Shiprocket smart cart — replaces the native drawer
          if (typeof slideShiprocketSmartCartInFrame === 'function') {
            slideShiprocketSmartCartInFrame();
          } else if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
            Alpine.store('xCartNoti').setItem(data);
          } else {
            Alpine.store('xMiniCart').openCart();
            document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          }

            // if (data.status) {
            // console.error('Add to cart failed:', data.description);
            // $btn.removeAttr("aria-busy");
            // return;
            // }

            // $btn.removeAttr("aria-busy");
            // $btn.removeClass('active');

            // // ✅ Step 1 — Re-render Eurus cart sections
            // if (data.sections) {
            // Alpine.store('xCartHelper').reRenderSections(data.sections);
            // }

            // // ✅ Step 2 — Close QuickView if open
            // if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
            // Alpine.store('xQuickView').show = false;
            // }

            // // ✅ Step 3 — Open cart drawer or show notification
            // if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
            // Alpine.store('xCartNoti').setItem(data);
            // } else {
            // Alpine.store('xMiniCart').openCart();
            // document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
            // }

            // // ✅ Step 4 — Update cart icon count
            // Alpine.store('xCartHelper').currentItemCount =
            // parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || 0);

            // // ✅ Step 5 — Fire Eurus cart changed event
            // document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));     
        }.bind(this));  
    });

    $('body').on('click','.block-product-offers-header', function () {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });

    $("body").on("click", ".bpoi-copybtn", function () {
      var copied_text = $(this).closest('.block-product-offer-item').find('.bpoi-coupon-copied');
      var text = $(this).closest('.block-product-offer-item').find('.bpoi-con-code').attr('data-code');
      var $temp = $("<input>");
      console.log('copied_text',copied_text);
      console.log('text',text);
        
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copied_text.addClass('copied');
        
      setTimeout(function () {
        copied_text.removeClass('copied');
      }, 2000);
    });

    const slideshow_sec_autoplay = $('.slideshow-sec-blocks').attr('autoplay');
    $(".slideshow-sec-blocks").slick({
      dots: true,
      arrows:false,
      autoplay: slideshow_sec_autoplay,
      autoplaySpeed: 5000,
      infinite:true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

     // Product page banner blocks (below add to cart) — one autoplay slider
    function initProductBannerSlider() {
      $(".x-block-image-slider").each(function () {
        var $slider = $(this);
        if ($slider.hasClass('slick-initialized')) { return; }
        $slider.slick({
          dots: false,
          arrows: false,
          autoplay: $slider.data('autoplay') === true,
          autoplaySpeed: parseInt($slider.data('autoplay-speed')) || 4000,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      });
    }
    initProductBannerSlider();
    // re-init when the section is re-rendered in the theme editor
    document.addEventListener('shopify:section:load', initProductBannerSlider);

    $(".tesi-shilajit-blocks").slick({
      dots: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      infinite:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-arrow slick-prev">←</button>',
      nextArrow: '<button class="slick-arrow slick-next">→</button>'
    });

    $('body').on('click','.faq-shilajit-block-title', function() {
      $(this).toggleClass('active');
      $(this).next().toggleClass('active');
    })
    
    $('body').on('click', '.mubc-button-first, .pack-s-s-bar-btn, .shilajit-header-button', function(e) {
      e.preventDefault();
      var target = $(this).attr('href');
      if ($(target).length) {
        $('html, body').animate({
          scrollTop: $(target).offset().top + 30
        }, 500);
      }
    });

    // $('body').on('click','.mf-packs__btn', function(){     
    //   var $btn = $(this);
    //   $btn.attr("aria-busy",true);
    //   $btn.addClass('active');
    //   var val = $(this).attr('data-id');        
    //   var items = [];        
    //   items.push({
    //       quantity: 1,
    //       id: val
    //   });
    //   var data = {items};
    //   console.log('data',data)
    //   // var data = theme.utils.serialize(this.form);  
    //   fetch('/cart/add.js', {
    //     method: 'POST',
    //     body: JSON.stringify(data),
    //     credentials: 'same-origin',
    //     headers: {
    //       'Content-Type': 'application/json; charset=UTF-8',
    //       'X-Requested-With': 'XMLHttpRequest'
    //   },
    //   body:  JSON.stringify({ "items": items, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
    //   })
    //   .then(response => response.json())
    //   .then(function(data) {      
    //       if (data.status) {
    //       console.error('Add to cart failed:', data.description);
    //       $btn.removeAttr("aria-busy");
    //       return;
    //       }

    //       $btn.removeAttr("aria-busy");
    //       $btn.removeClass('active');

    //       // ✅ Step 1 — Re-render Eurus cart sections
    //       if (data.sections) {
    //       Alpine.store('xCartHelper').reRenderSections(data.sections);
    //       }

    //       // ✅ Step 3 — Open cart drawer or show notification
    //       if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
    //       Alpine.store('xCartNoti').setItem(data);
    //       } else {
    //       Alpine.store('xMiniCart').openCart();
    //       // document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
    //       }

    //       // ✅ Step 4 — Update cart icon count
    //       Alpine.store('xCartHelper').currentItemCount =
    //       parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || 0);

    //       // ✅ Step 5 — Fire Eurus cart changed event
    //       document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));     
    //   }.bind(this));
    // })

})